import Vue from 'vue'
var baseURL1 = 'https://product.rakumart.com'
import { baseURL } from '../config'
let token = localStorage.getItem('token')
// 自营产品
export const getList = data => Vue.prototype.postAxios(baseURL1 + "/api/product/list", data)
// 1688
export const getList1688 = data => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=offersearch1&token="+token, data)

// 搜索
export const taobaoShortUrl = data => Vue.prototype.postAxios(baseURL1 + "/api/product/taobaoShortUrl", data)

// 获取商品id
export const getGoodsId = data => Vue.prototype.postAxios("https://www.rakumart-2c.com:8080/api/getGoodsId", data)

